import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {forgotPassword, requestPassword} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})
interface propDataType {
  setShowForgotPassword: (show: boolean) => void
}
export function ForgotPassword({setShowForgotPassword}: propDataType) {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<string | undefined>(undefined)
  const [success, setSuccess] = useState<Boolean>(false)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      try {
        const {data: res} = await forgotPassword(formik.values.email)
        if (res.code === '200') {
          setHasErrors(res.msg_details)
          setSuccess(true)
        } else {
          setHasErrors(res.msg_details)
          setSuccess(false)
        }
      } catch (error: any) {
        setHasErrors(error)
        setSuccess(false)
      } finally {
        setLoading(false)
      }
    },
  })
  const handleCancel = () => {
    setShowForgotPassword(false)
  }
  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      {success ? (
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <img
              className='w-50 h-25 p-8'
              src={toAbsoluteUrl('/media/svg/undraw/register_success.svg')}
              alt='Registration success'
            />
          </div>
          <p
            className='text-muted fs-3 font-weight-bold d-flex flex-column justify-content-center align-items-center'
            style={{fontWeight: '600'}}
          >
            <span>We have sent the login credential to your email.</span>
            <span>Please use it to login.</span>
          </p>

          <button id='kt_password_reset_submit shadow-sm' className='btn btn-primary me-4'>
            <span className='indicator-label' onClick={handleCancel}>
              Go to login
            </span>
          </button>
        </div>
      ) : (
        <>
          {/* begin::Title */}
          {hasErrors && (
            <div className='h-100px'>
              <div className='alert alert-danger'>
                <div className='alert-text font-weight-bold'>
                  <i
                    className='bi bi-patch-exclamation-fill fs-2 text-danger'
                    title='Tenant is blocked'
                  ></i>
                  {hasErrors}
                </div>
              </div>
            </div>
          )}
          {/* end::Title */}
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='text-gray-500 fw-semibold fs-6'>Please enter your email</div>
            {/* end::Link */}
          </div>

          {/* begin::Form group */}
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
            <input
              type='email'
              placeholder=''
              autoComplete='off'
              {...formik.getFieldProps('email')}
              className={clsx(
                'form-control bg-transparent',
                {'is-invalid': formik.touched.email && formik.errors.email},
                {
                  'is-valid': formik.touched.email && !formik.errors.email,
                }
              )}
            />
            {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.email}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              type='submit'
              id='kt_password_reset_submit shadow-sm'
              className='btn btn-primary me-4'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {loading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Processing...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <span className='indicator-label'>Submit</span>
              )}
            </button>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-light bg-color-white shadow-sm me-4 btn-active-light-primary'
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
          {/* end::Form group */}
        </>
      )}
    </form>
  )
}
